import {
  ConeGeometry,
  BoxGeometry,
  Group,
  Mesh,
  MeshStandardMaterial,
  SphereGeometry
} from 'three';

/** Riven mesh — broken-blade fighter silhouette. */
export function createRivenMesh(team = 'blue') {
  const group = new Group();
  const trim = team === 'blue' ? 0xa78bfa : 0xfbbf24;
  const bodyMat = new MeshStandardMaterial({ color: 0x312e81, roughness: 0.45 });
  const trimMat = new MeshStandardMaterial({ color: trim, roughness: 0.3, metalness: 0.45 });
  const body = new Mesh(new ConeGeometry(0.52, 1.9, 10), bodyMat);
  body.position.y = 1.1;
  group.add(body);
  const head = new Mesh(new SphereGeometry(0.33, 12, 12), trimMat);
  head.position.y = 2.25;
  group.add(head);
  const blade = new Mesh(new BoxGeometry(0.12, 0.7, 0.08), trimMat);
  blade.position.set(0.6, 1.35, 0.1);
  group.add(blade);
  return group;
}
